import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'composed-course-status-component',
  template: `<div class="cell-values">
    <span vrm-course-status-color [status]="status.rawValue" *ngIf="status.rawValue !== 'NA'; else statusNA">
      {{ status.translatedValue | titlecase }}{{ rest }}
    </span>
    <ng-template #statusNA>
      {{ status.translatedValue }}
    </ng-template>
  </div>`,
  styles: [],
})
export class ComposedCourseStatusComponent implements ICellRendererAngularComp {
  public status: any;
  public rest: string;

  private statusMapping = {
    Complete: { rawValue: 'Complete', translatedValue: this.cService.readyTranslations.reportData.complete },
    Incomplete: { rawValue: 'Incomplete', translatedValue: this.cService.readyTranslations.reportData.incomplete },
    NotStarted: { rawValue: 'Not Started', translatedValue: this.cService.readyTranslations.reportData.notStarted },
    NA: { rawValue: 'NA', translatedValue: this.cService.readyTranslations.reportData.na },
  };

  /**
   * Creates a new instance of ComposedCourseStatusComponent
   */
  constructor(public translate: TranslateService, private cService: CommonService, public rptService: ReportsService) {}

  /**
   * Executes when the grid initialises
   */
  agInit(params: { value: any }) {
    if (!params.value) {
      return;
    }

    this.status = this.getMappedValue(params);
    this.rest = params.value.split(this.status.rawValue).pop();
  }

  private getMappedValue(params: { value: any }) {
    if (params.value.toLowerCase().includes(this.statusMapping.Incomplete.rawValue.toLowerCase())) {
      return this.statusMapping.Incomplete;
    }

    if (params.value.toLowerCase().includes(this.statusMapping.NotStarted.rawValue.toLowerCase())) {
      return this.statusMapping.NotStarted;
    }

    if (params.value.toLowerCase().includes(this.statusMapping.NA.rawValue.toLowerCase())) {
      return this.statusMapping.NA;
    }

    return this.statusMapping.Complete;
  }

  /**
   * Executed when the component is refreshed.
   */
  public refresh(): boolean {
    return false;
  }
}
